import React from "react";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar";
import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const CreateOrder = () => {
  const [orderDetails, setOrderDetails] = useState("");
  const location = useLocation();
  const { id } = location.state;

  const getOrderDetails = async () => {
    try {
      const response = await axios.get(
        `http://api.meddaily.in/order_details?order_id=${id}`,
        {
          headers: {
            token: localStorage.getItem("disToken"),
          },
        }
      );
      if (response.status === 200) {
        setOrderDetails(response?.data?.data);
        console.log(response.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getOrderDetails();
  }, [id]);

  const totalPriceqty =
    orderDetails?.products &&
    orderDetails.products.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
  const calTax = (totalPriceqty * orderDetails?.applicable_tax) / 100;
  const orderTotal = totalPriceqty + calTax + orderDetails?.delivery_fee;
  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Sidebar />
          <div className="layout-page">
            <Navbar />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className="card mb-12">
                    <div className="card-header d-flex justify-content-between align-items-center"></div>

                    <div className="card-body">
                      <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row">
                          <div className="card mb-3">
                            <div className="card-body">
                              <h2 className="card-title text-start">
                                Order Details
                              </h2>
                              <div className="row">
                                <div className="col-md-6">
                                  <strong>Order ID:</strong>{" "}
                                  {orderDetails?.order_id}
                                </div>
                                <div className="col-md-6">
                                  <strong>Distributor Name:</strong>{" "}
                                  {orderDetails?.distributor_name}
                                </div>
                                <div className="col-md-6">
                                  <strong>Retailer Name:</strong>{" "}
                                  {orderDetails?.retailer_name}
                                </div>
                                <div className="col-md-6">
                                  <strong>Order Status:</strong>{" "}
                                  {orderDetails?.order_status === 0 &&
                                    "Cancelled"}
                                  {orderDetails?.order_status === 1 &&
                                    "Order Shipped"}
                                  {orderDetails?.order_status === 3 &&
                                    "Order Delivered"}
                                  {orderDetails?.order_status === 4 &&
                                    "Order Placed"}
                                </div>
                                <div className="col-md-6">
                                  <strong>Batch no:</strong>{" "}
                                  {orderDetails?.batch_no}
                                </div>
                                <div className="col-md-6">
                                  <strong>Exp Date:</strong>{" "}
                                  {orderDetails?.exp_date}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="card mb-3">
                            <div className="card-body">
                              <h2 className="card-title text-start">
                                Order Items
                              </h2>
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {orderDetails?.products &&
                                    orderDetails.products.map(
                                      (product, index) => (
                                        <tr key={index}>
                                          <td>{product?.name}</td>
                                          <td>{product?.price}</td>
                                          <td>{product?.quantity}</td>
                                        </tr>
                                      )
                                    )}
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div className="card">
                            <div className="card-body">
                              <h2 className="card-title text-start">
                                Estimated Return Value
                              </h2>
                              <table className="table">
                                <tbody>
                                  <tr>
                                    <th scope="row">Item Total:</th>
                                    <td>{totalPriceqty}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Tax:</th>
                                    <td>{calTax}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Delivery Fee:</th>
                                    <td>{orderDetails?.delivery_fee}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Return Total:</th>
                                    <td>{orderTotal}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-5">
                      {/* {orderDetails?._id && (
                        <Link
                          to={{
                            pathname: "/invoice",
                            state: {
                              orderid: id,
                            },
                          }}
                        >
                          <button
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#6eafab",
                              border: "1px solid #6eafab",
                            }}
                          >
                           Approve Return
                          </button>
                        </Link>
                      )} */}
                      {/* {orderDetails?._id && (
                        <button
                          className="btn btn-primary"
                          style={{
                            backgroundColor: "#6eafab",
                            border: "1px solid #6eafab",
                          }}
                          //   onClick={handleApprove}
                        >
                          Crerate Invoice
                        </button>
                      )} */}
                      {orderDetails?._id &&
                        orderDetails?.order_status === 4 && (
                          <Link
                            to={{
                              pathname: "/invoice",
                              state: {
                                orderid: id,
                              },
                            }}
                          >
                            <button
                              className="btn btn-primary"
                              style={{
                                backgroundColor: "#6eafab",
                                border: "1px solid #6eafab",
                              }}
                            >
                              Create Invoice
                            </button>
                          </Link>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateOrder;
